// extracted by mini-css-extract-plugin
module.exports = {"sub_title":"mentor_connect_sub_title__RWGhG","connect_card":"mentor_connect_connect_card__rZf2F","card_title":"mentor_connect_card_title__54DGC"};